<template>
	<div
		id="app"
		:class="vueAppClasses"
	>
		<div id="loading-bg">
		
			<div class="loadingText">Carregando...</div>
		</div>
		<router-view @setAppClasses="setAppClasses" />
	</div>
</template>

<script>
import themeConfig from "@/../siteThemeConfig.js";
import jwt from "@/http/requests/authSite/jwt/index.js";

export default {
	props: {
		topo: {
			type: String,
			required: false,
		},
		textoTopo: {
			type: String,
			required: false,
		},
		error: {
			type: String,
			required: false,
		},
		errorTitle: {
			type: String,
			required: false,
		},
		errorCode: {
			type: String,
			required: false,
		},
		buttonTitle: {
			type: String,
			required: false,
		},
		buttonLink: {
			type: String,
			required: false,
		},
		recaptchaSitekey: {
			type: String,
			required: false,
		},
		termosTeste: {
			type: String,
			required: false,
		},
		regraEstiloTeste: {
			type: String,
			required: false,
		},
		siteNome: {
			type: String,
			required: false,
		},
		siteEmail: {
			type: String,
			required: false,
		},
		siteEmpresa: {
			type: String,
			required: false,
		},
		siteEnderecoEmail: {
			type: String,
			required: false,
		},
		politicaPrivacidade: {
			type: Boolean,
			required: false,
			default: false,
		},
		filListaTipoSexosData: {
			type: String,
			required: false,
		},
		filListaTipoCategoriasData: {
			type: String,
			required: false,
		},
		listaPrincipaisCidadesData: {
			type: String,
			required: false,
		},
		listaPrincipaisPesquisasData: {
			type: String,
			required: false,
		},
		filtrosData: {
			type: String,
			required: false,
		},
		anunciosIdsData: {
			type: String,
			required: false,
		},
		listaAnunciosData: {
			type: String,
			required: false,
		},
		listaAnunciosHistoriaData: {
			type: String,
			required: false,
		},
		listaAnunciosDisponivelData: {
			type: String,
			required: false,
		},
		anuncioData: {
			type: String,
			required: false,
		},
	},
	data() {
		return {
			pageName: "site",
			vueAppClasses: [],
			checkLoggedUserTimeout: null,
			idUsuario: null,
			idPerfil: null,
		};
	},
	computed: {
		bannerTopo() {
			if (this.topo) {
				return this.topo;
			} else if (this.$root && this.$root.topo) {
				return this.$root.topo;
			}
			return null;
		},
		filListaTipoSexosDados() {
			if (this.filListaTipoSexosData) {
				if (typeof this.filListaTipoSexosData == "string") {
					return JSON.parse(this.filListaTipoSexosData);
				}
				return this.filListaTipoSexosData;
			} else if (this.$root && this.$root.filListaTipoSexosData) {
				if (typeof this.$root.filListaTipoSexosData == "string") {
					return JSON.parse(this.$root.filListaTipoSexosData);
				}
				return this.$root.filListaTipoSexosData;
			}
			return null;
		},
		filListaTipoCategoriasDados() {
			if (this.filListaTipoCategoriasData) {
				if (typeof this.filListaTipoCategoriasData == "string") {
					return JSON.parse(this.filListaTipoCategoriasData);
				}
				return this.filListaTipoCategoriasData;
			} else if (this.$root && this.$root.filListaTipoCategoriasData) {
				if (typeof this.$root.filListaTipoCategoriasData == "string") {
					return JSON.parse(this.$root.filListaTipoCategoriasData);
				}
				return this.$root.filListaTipoCategoriasData;
			}
			return null;
		},
		listaPrincipaisCidadesDados() {
			if (this.listaPrincipaisCidadesData) {
				if (typeof this.listaPrincipaisCidadesData == "string") {
					return JSON.parse(this.listaPrincipaisCidadesData);
				}
				return this.listaPrincipaisCidadesData;
			} else if (this.$root && this.$root.listaPrincipaisCidadesData) {
				if (typeof this.$root.listaPrincipaisCidadesData == "string") {
					return JSON.parse(this.$root.listaPrincipaisCidadesData);
				}
				return this.$root.listaPrincipaisCidadesData;
			}
			return null;
		},
		listaPrincipaisPesquisasDados() {
			if (this.listaPrincipaisPesquisasData) {
				if (typeof this.listaPrincipaisPesquisasData == "string") {
					return JSON.parse(this.listaPrincipaisPesquisasData);
				}
				return this.listaPrincipaisPesquisasData;
			} else if (this.$root && this.$root.listaPrincipaisPesquisasData) {
				if (typeof this.$root.listaPrincipaisPesquisasData == "string") {
					return JSON.parse(this.$root.listaPrincipaisPesquisasData);
				}
				return this.$root.listaPrincipaisPesquisasData;
			}
			return null;
		},
		filtrosDados() {
			if (this.filtrosData) {
				if (typeof this.filtrosData == "string") {
					return JSON.parse(this.filtrosData);
				}
				return this.filtrosData;
			} else if (this.$root && this.$root.filtrosData) {
				if (typeof this.$root.filtrosData == "string") {
					return JSON.parse(this.$root.filtrosData);
				}
				return this.$root.filtrosData;
			}
			return null;
		},
		anunciosIdsDados() {
			if (this.anunciosIdsData) {
				return this.anunciosIdsData;
			} else if (this.$root && this.$root.anunciosIdsData) {
				return this.$root.anunciosIdsData;
			}
			return null;
		},
		listaAnunciosDados() {
			if (this.listaAnunciosData) {
				if (typeof this.listaAnunciosData == "string") {
					return JSON.parse(this.listaAnunciosData);
				}
				return this.listaAnunciosData;
			} else if (this.$root && this.$root.listaAnunciosData) {
				if (typeof this.$root.listaAnunciosData == "string") {
					return JSON.parse(this.$root.listaAnunciosData);
				}
				return this.$root.listaAnunciosData;
			}
			return null;
		},
		listaAnunciosHistoriaDados() {
			if (this.listaAnunciosHistoriaData) {
				if (typeof this.listaAnunciosHistoriaData == "string") {
					return JSON.parse(this.listaAnunciosHistoriaData);
				}
				return this.listaAnunciosHistoriaData;
			} else if (this.$root && this.$root.listaAnunciosHistoriaData) {
				if (typeof this.$root.listaAnunciosHistoriaData == "string") {
					return JSON.parse(this.$root.listaAnunciosHistoriaData);
				}
				return this.$root.listaAnunciosHistoriaData;
			}
			return null;
		},
		listaAnunciosDisponivelDados() {
			if (this.listaAnunciosDisponivelData) {
				if (typeof this.listaAnunciosDisponivelData == "string") {
					return JSON.parse(this.listaAnunciosDisponivelData);
				}
				return this.listaAnunciosDisponivelData;
			} else if (this.$root && this.$root.listaAnunciosDisponivelData) {
				if (typeof this.$root.listaAnunciosDisponivelData == "string") {
					return JSON.parse(this.$root.listaAnunciosDisponivelData);
				}
				return this.$root.listaAnunciosDisponivelData;
			}
			return null;
		},
		anuncioDados() {
			if (this.anuncioData) {
				if (typeof this.anuncioData == "string") {
					return JSON.parse(this.anuncioData);
				}
				return this.anuncioData;
			} else if (this.$root && this.$root.anuncioData) {
				if (typeof this.$root.anuncioData == "string") {
					return JSON.parse(this.$root.anuncioData);
				}
				return this.$root.anuncioData;
			}
			return null;
		},
	},
	watch: {
		"$store.state.theme"(val) {
			this.toggleClassInBody(val);
		},
		"$vs.rtl"(val) {
			document.documentElement.setAttribute("dir", val ? "rtl" : "ltr");
		},
		"$store.state.logoutAsked"(val) {
			if (val) {
				/*this.stopNchanClientUsuario();
				this.stopNchanClientFuncionalidades();*/
			}
		},
		"$store.state.AppActiveUser.userRole"(val) {
			if (!val) {
				this.$acl.change(themeConfig.userDefaultRole);
			} else {
				this.$acl.change(val);
			}
		},
		"$store.state.AppActiveUser.idPerfil"(val) {
			if (val) {
				if (this.idPerfil != val /*|| !this.nchanClientFuncionalidadesStarted()*/) {
					this.idPerfil = val;
				}
			} else {
				this.idPerfil = null;
			}
		},
		"$store.state.AppActiveUser.idUsuario"(val) {
			if (val) {
				if (this.idUsuario != val /*|| !this.nchanClientUsuarioStarted()*/) {
					this.idUsuario = val;
				}
			} else {
				this.idUsuario = null;
			}
		},
	},
	methods: {
		onStorageUpdate(event) {
			if (event.key === themeConfig.userInfoLocalStorageKey) {
				console.log("USERINFO UPDATED FROM STORAGE", event);
				if (event.newValue == null) {
					console.log("userInfo updated from storage", event);
					this.$store.commit("auth/REMOVE_BEARER");
					this.$store.commit("REMOVE_USER_INFO");
				} else {
					try {
						let userInfo = JSON.parse(event.newValue);
						this.$store.dispatch("updateUserInfo", userInfo);
					} catch (err) {}
				}
			}
		},
		onUnload(event) {
			console.log(this.pageName, "ON UNLOAD");
		},
		onBeforeUnload(event) {
			//console.log("SITE onBeforeUnload", event);
			/*if (this.checkLoggedUserTimeout) {
				clearTimeout(this.checkLoggedUserTimeout);
				this.checkLoggedUserTimeout = null;
			}*/
			window.removeEventListener("storage", this.onStorageUpdate);
			window.removeEventListener("resize", this.handleWindowResize);
			window.removeEventListener("scroll", this.handleScroll);
			window.removeEventListener("beforeunload", this.onBeforeUnload);

			console.log(this.pageName, "ON BEFORE UNLOAD");
		},
		toggleClassInBody(className) {
			if (className == "dark") {
				if (document.body.className.match("theme-semi-dark")) document.body.classList.remove("theme-semi-dark");
				document.body.classList.add("theme-dark");
			} else if (className == "semi-dark") {
				if (document.body.className.match("theme-dark")) document.body.classList.remove("theme-dark");
				document.body.classList.add("theme-semi-dark");
			} else {
				if (document.body.className.match("theme-dark")) document.body.classList.remove("theme-dark");
				if (document.body.className.match("theme-semi-dark")) document.body.classList.remove("theme-semi-dark");
			}
		},
		setAppClasses(classesStr) {
			this.vueAppClasses.push(classesStr);
			console.log("veio para o setAppClasses")
		},
		handleWindowResize() {
			this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

			document.documentElement.style.setProperty("--vh", `${window.innerHeight * 0.01}px`);
		},
		handleScroll() {
			this.$store.commit("UPDATE_WINDOW_SCROLL_Y", window.scrollY);
		},
		loggedUser() {
			var self = this;
			return new Promise((resolve, reject) => {
				if (self.$store.getters.isUserLoggedIn) {
					self.$store.commit("auth/SET_BEARER", self.$store.state.AppActiveUser.contaToken);
					self.$acl.change(self.$store.state.AppActiveUser.userRole);
					self.$store
						.dispatch("auth/refreshJWTToken", {
							token: self.$store.state.AppActiveUser.contaToken,
						})
						.then((response) => {
							if (self.$store.state.AppActiveUser.idPerfil) {
								if (self.idPerfil != self.$store.state.AppActiveUser.idPerfil /*|| !self.nchanClientFuncionalidadesStarted()*/) {
									self.idPerfil = self.$store.state.AppActiveUser.idPerfil;
								}
							} else {
								self.idPerfil = null;
							}
							if (self.$store.state.AppActiveUser.idUsuario) {
								if (self.idUsuario != self.$store.state.AppActiveUser.idUsuario /*|| !self.nchanClientUsuarioStarted()*/) {
									self.idUsuario = self.$store.state.AppActiveUser.idUsuario;
								}
							} else {
								self.idUsuario = null;
							}
							resolve(true);
						})
						.catch((error) => {
							self.idPerfil = null;
							self.idUsuario = null;
							reject(error);
						});
				} else {
					self.$store.commit("auth/REMOVE_BEARER");
					self.$store.commit("REMOVE_USER_INFO");
					self.idPerfil = null;
					self.idUsuario = null;
					self.$store
						.dispatch("auth/refreshJWTToken", {
							token: null,
						})
						.then((response) => {
							if (self.$store.state.AppActiveUser.idPerfil) {
								if (self.idPerfil != self.$store.state.AppActiveUser.idPerfil /*|| !self.nchanClientFuncionalidadesStarted()*/) {
									self.idPerfil = self.$store.state.AppActiveUser.idPerfil;
								}
							} else {
								self.idPerfil = null;
							}
							if (self.$store.state.AppActiveUser.idUsuario) {
								if (self.idUsuario != self.$store.state.AppActiveUser.idUsuario /*|| !self.nchanClientUsuarioStarted()*/) {
									self.idUsuario = self.$store.state.AppActiveUser.idUsuario;
								}
							} else {
								self.idUsuario = null;
							}
							reject(new Error("err"));
						})
						.catch((error) => {
							self.idPerfil = null;
							self.idUsuario = null;
							reject(error);
							console.log("Chegou ao final do código")
						});
				}
			});
		},
		openLoading() {
			this.$router.isBusy = true;
			this.$store.commit("ROUTER_IS_BUSY", true);
			const vsLoading = document.getElementById("content-area");
			if (this && this.$vs && vsLoading) {
				console.log("vai carregar");
				this.$vs.loading({
					color: "#000000",
					//background: '#008FD5',
					background: "rgba(0, 0, 0, 0.75)",
					//container: '#router-content',
					//container: '#router-view',
					container: "#content-area",
					//type: "radius",
					text: "Carregando...",

				});
			} else {
				//console.log("beforeEach main");
				const appLoading = document.getElementById("loading-bg");
				if (appLoading) {
					appLoading.style.display = "";
				}
			}
		},
		closeLoading() {
			//console.log("closeLoading");
			const appLoading = document.getElementById("loading-bg");
			if (appLoading) {
				//console.log("MAIN LOADING CLOSE");
				appLoading.style.display = "none";
			}
			const vsLoading = document.getElementById("content-area");
			if (this && this.$vs && this.$vs.loading && vsLoading) {
				//console.log("ROUTER LOADING CLOSE");
				this.$vs.loading.close("#content-area > .con-vs-loading");
			}
			this.$router.isBusy = false;
			this.$store.commit("ROUTER_IS_BUSY", false);
		},
		logout(button) {
			this.openLoading();
			var self = this;
			return new Promise((resolve, reject) => {
				self.$store
					.dispatch("auth/logoutJWT")
					.then((response) => {
						self.closeLoading();
						self.$vs.notify({
							title: "Saindo",
							text: "Redirecionando...",
							iconPack: "feather",
							icon: "icon-user",
							color: "success",
						});
						setTimeout(function() {
							document.location.href = "/conta/entrar";
						}, 1000);
						resolve(true);
					})
					.catch((error) => {
						self.closeLoading();
						var errMsg = "Request error.";
						if (error && error.response && error.response.data && error.response.data.error) {
							errMsg = error.response.data.error;
						} else if (error && error.response && error.response.data && error.response.data.message) {
							errMsg = error.response.data.message;
						} else if (error && error.message) {
							errMsg = error.message;
						}
						self.$vs.notify({
							title: "Erro",
							text: errMsg,
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
						});
						if (error && error.response && (error.response.status == 428 || error.response.status == 401)) {
							setTimeout(function() {
								document.location.reload();
							}, 1000);
						}
						reject(error);
					});
			});
		},
	},
	mounted() {
		var self = this;
		window.siteApp = this;

		console.log(this.pageName, "MOUNTED");

		this.toggleClassInBody(themeConfig.theme);
		this.$store.commit("UPDATE_WINDOW_WIDTH", window.innerWidth);

		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty("--vh", `${vh}px`);

		if (this.$store.getters.isUserLoggedIn) {
			this.$acl.change(this.$store.state.AppActiveUser.userRole);
		} else {
			this.$acl.change([themeConfig.userDefaultRole]);
		}
		this.$router.start();
	},
	async created() {
		console.log("SITE.VUE CARREGOU");
		jwt.init();

		let dir = this.$vs.rtl ? "rtl" : "ltr";
		document.documentElement.setAttribute("dir", dir);

		window.addEventListener("resize", this.handleWindowResize);
		window.addEventListener("scroll", this.handleScroll);
		window.addEventListener("storage", this.onStorageUpdate);
		window.addEventListener("beforeunload", this.onBeforeUnload);
		window.addEventListener("unload", this.onUnload);

		console.log(this.pageName, "CREATED");
	},
	/*destroyed() {
		window.removeEventListener("resize", this.handleWindowResize);
		window.removeEventListener("scroll", this.handleScroll);
	},*/
	beforeDestroy() {
		//console.log("beforeDestroy");
		this.onBeforeUnload("beforeDestroy");
	},
};
</script>
